export enum SuctionLeakageType {
  Suction = 'Учитывать',
  // Leak = 'Утечка',
  Overlook = 'Не учитывать',
}
